import "lightgallery/css/lg-thumbnail.css";
import "lightgallery/css/lg-zoom.css";
import "lightgallery/css/lightgallery.css";
import lgThumbnail from "lightgallery/plugins/thumbnail";
import lgZoom from "lightgallery/plugins/zoom";
import lgVideo from "lightgallery/plugins/video";
import LightGallery from "lightgallery/react";
import React, { useEffect, useState } from "react";
import { Col, Container, ListGroup, Spinner } from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";

import ImageElement from "components/ImageElement";

import { BROKER_ENDPOINT } from "apiEndpoints";
import userRouteMap from "routes/User/userRouteMap";
import { commonService } from "services/common.service";
import socketEventManager from "socket/socketEvents";
import { removeBordersFromCursorPointerImages } from "utils/helpers";

function MeetingRoom() {
  const location = useLocation();
  const navigate = useNavigate();
  const [state, setState] = useState({
    isLoading: true,
    lists: [],
    activeChild: {},
    media: [],
  });
  
  // Check if private mode is enabled
  const localValue = localStorage.getItem("privateMode");
  const isPrivateMode = localValue === "true";

  const getPageDatails = async () => {
    try {
      const response = await commonService({
        apiEndPoint: BROKER_ENDPOINT.getCategoryDetails(location.state.id),
      });
      setState({
        ...state,
        isLoading: false,
        lists: response?.data?.data ?? [],
        activeChild: {
          parentIndex: 0,
          childIndex: 0,
        },
        media: response?.data?.data?.[0]
          ? (response.data?.data?.[0]?.child_category
            ?.map?.((item) => item?.media)
            ?.flat?.() ?? [])
          : [],
      });
    } catch (error) {
      setState((prevState) => ({
        ...prevState,
        isLoading: false,
      }));
    }
  };
  const handleChangeOption = (parentIndex, childIndex = null) => {
    removeBordersFromCursorPointerImages();
    
    const isChildClicked =
      typeof childIndex === "number" &&
      state?.lists?.[parentIndex]?.child_category?.[childIndex];

    const media = isChildClicked
      ? (state.lists[parentIndex].child_category[childIndex]?.media ?? [])
      : state.lists[parentIndex]?.child_category
        ?.map((item) => item?.media ?? [])
        ?.flat();

    setState((prevState) => ({
      ...prevState,
      activeChild: { parentIndex, childIndex },
      media,
    }));
  };

  const handleSocketCommand = (item, thisImage) => {
    if (isPrivateMode) {
      return;
    }
    if (thisImage) {
      removeBordersFromCursorPointerImages();
      // add border class to the image which is clicked
      thisImage.classList.add('bordered');
    }
    const primarySocketObject = {
      hardware_id: item?.hardware_id,
      broker_id: item?.broker_id,
      sub_sub_category_id: item?.sub_sub_category_id,
      'cross_fade': true,
      type: "gallery_image",
      image_id: item?.media_id,
      image_url: item?.image_name,
    }

    const secondarySocketObject = {
      hardware_id: item?.secondary_image[0]?.hardware_id,
      broker_id: item?.broker_id,
      sub_sub_category_id: item?.sub_sub_category_id,
      'cross_fade': true,
      type: "gallery_image",
      image_id: item?.secondary_image[0]?.media_id,
      image_url: item?.secondary_image[0]?.image_name,
    }
    if (item?.image_name) {
      console.log("primarySocketObject", primarySocketObject);
      socketEventManager.sendCommand(item?.hardware_id, primarySocketObject);
    }

    if (item?.secondary_image[0]) {
      console.log("secondarySocketObject", secondarySocketObject);
      socketEventManager.sendCommand(item?.secondary_player, secondarySocketObject);
    }
  }
  const handleAfterSlide = (detail) => {
    const index = detail?.index; // The new slide index
    const item = state?.media?.[index];
    if (item) {
      // handleSocketCommand(item);
    }
  };

  useEffect(() => {
    if (!location.state) {
      navigate("/");
    } else {
      getPageDatails();
    }
  }, []);

  return (
    <>
      <div className="mainContent_inner pb-0 h-100vh">
        <Container fluid className="position-relative">
          <Link
            className="commonBack commonBack_topLeft text-uppercase d-block h-auto position-absolute z-1"
            onClick={() => navigate(-1)}
          >
            <em className="icon-back" />
            <span className="d-block">Back</span>
          </Link>
          <div className="row">
            <Col md={6} className=" pe-lg-5">
              <div className="imgGrid imgGrid-full position-relative d-flex flex-column align-items-center">
                <div
                  className={
                    !state.isLoading
                      ? "imgGrid_inner d-flex flex-column w-100"
                      : ""
                  }
                >
                  {state.isLoading ? (
                    <div className="d-flex justify-content-center align-items-center m-auto">
                      <Spinner />
                    </div>
                  ) : !state.isLoading && state.media.length > 0 ? (
                    isPrivateMode ? (
                      <LightGallery
                        elementClassNames="gallery-container row gx-2 gy-2"
                        speed={500}
                        mobileSettings={{
                          controls: true,
                          showCloseIcon: true,
                          download: true,
                        }}
                        plugins={[lgThumbnail, lgZoom, lgVideo]}
                        onAfterSlide={handleAfterSlide}
                      >
                        {state?.media?.map((item, index) => (
                          <React.Fragment key={index}>
                            {/* Primary Image */}
                            <a
                              className="imgGrid_item col-lg-6 col-6"
                              href={item?.image_name}
                            >
                              <div className="position-relative">
                                <ImageElement
                                  imageFor="user"
                                  // onClick={() => handleSocketCommand(item)}
                                  previewSource={item?.image_name}
                                  className="img-fluid"
                                  alt="loung-room-primary"
                                />
                                {item?.hasVideo && (
                                  <div className="playIcon d-flex align-items-center justify-content-center position-absolute">
                                    <em className="icon-play" />
                                  </div>
                                )}
                              </div>
                              <h3 className="imgGrid_item_label text-uppercase mt-1">
                                {item?.title}
                              </h3>
                            </a>

                            {/* Secondary Image (if available) */}
                            {item?.secondary_image?.[0]?.thumb_name && (
                              <a
                                className="imgGrid_item col-lg-6 col-6"
                                href={item?.secondary_image[0]?.thumb_name}
                              >
                                <div className="position-relative">
                                  <ImageElement
                                    imageFor="user"
                                    previewSource={
                                      item?.secondary_image[0]?.thumb_name
                                    }
                                    className="img-fluid"
                                    alt="loung-room-secondary"
                                  />
                                  {item?.hasVideo && (
                                    <div className="playIcon d-flex align-items-center justify-content-center position-absolute">
                                      <em className="icon-play" />
                                    </div>
                                  )}
                                </div>
                                <h3 className="imgGrid_item_label text-uppercase mt-1">
                                  {item?.title}
                                </h3>
                              </a>
                            )}
                          </React.Fragment>
                        ))}
                      </LightGallery>
                    ) : (
                      <div className="gallery-container row gx-2 gy-2">
                        {state?.media?.map((item, index) => (
                          <React.Fragment key={index}>
                            {/* Primary Image */}
                            <div className="imgGrid_item col-lg-6 col-6 cursor-pointer">
                              <div className="position-relative">
                                <ImageElement
                                  imageFor="user"
                                  onClick={(e) => handleSocketCommand(item, e.currentTarget)}
                                  previewSource={item?.image_name}
                                  className="img-fluid"
                                  alt="loung-room-primary"
                                />
                                {item?.hasVideo && (
                                  <div className="playIcon d-flex align-items-center justify-content-center position-absolute">
                                    <em className="icon-play" />
                                  </div>
                                )}
                              </div>
                              <h3 className="imgGrid_item_label text-uppercase mt-1">
                                {item?.title}
                              </h3>
                            </div>

                            {/* Secondary Image (if available) */}
                            {item?.secondary_image?.[0]?.thumb_name && (
                              <div className="imgGrid_item col-lg-6 col-6 cursor-pointer">
                                <div className="position-relative">
                                  <ImageElement
                                    imageFor="user"
                                    previewSource={
                                      item?.secondary_image[0]?.thumb_name
                                    }
                                    className="img-fluid"
                                    alt="loung-room-secondary"
                                  />
                                  {item?.hasVideo && (
                                    <div className="playIcon d-flex align-items-center justify-content-center position-absolute">
                                      <em className="icon-play" />
                                    </div>
                                  )}
                                </div>
                                <h3 className="imgGrid_item_label text-uppercase mt-1">
                                  {item?.title}
                                </h3>
                              </div>
                            )}
                          </React.Fragment>
                        ))}
                      </div>
                    )
                  ) : (
                    <div className="d-flex justify-content-center align-items-center vh-100">
                      No data found
                    </div>
                  )}
                </div>
              </div>
            </Col>

            <Col
              md={6}
              className="position-md-relative d-flex flex-column align-items-center justify-content-between"
            >
              <div className="header w-100 d-flex align-items-center pe-1">
                <div className="header_title mx-auto">
                  <h1 className="mb-0">{location?.state?.name}</h1>
                </div>
                <Link className="header_logo" to={userRouteMap.LANDING.path}>
                  <ImageElement
                    imageFor="user"
                    source="logo.svg"
                    alt="logo"
                    className="img-fluid"
                  />
                </Link>
              </div>
              <div className="d-flex flex-column justify-content-around align-items-center multiList multiList-active multiList-tab multiList-scrollable">
                <div
                  className={
                    !state.isLoading ? "text-center innerScroll px-3" : ""
                  }
                >
                  {state.isLoading ? (
                    <div className="d-flex justify-content-center align-items-center m-auto">
                      <Spinner />
                    </div>
                  ) : !state.isLoading && state.lists.length > 0 ? (
                    <>
                      <h2 className="text-uppercase innerHead">GALLERY</h2>
                      <div className="landingPage_right_menu text-center innerScroll px-3">
                        <>
                          <ListGroup className="flex-column">
                            {state.lists.map((listItem, idx) => (
                              <ListGroup.Item
                                className="multiList_item"
                                key={idx}
                              >
                                <Link
                                  className={`multiList_item_tab ${state.activeChild?.parentIndex === idx
                                      ? "active-heading"
                                      : ""
                                    }`}
                                  onClick={(e) => {
                                    e.preventDefault();
                                    if (
                                      listItem?.category_type === "property"
                                    ) {
                                      navigate(
                                        userRouteMap.MEETINGFLOORPLAN.path,
                                        { state: listItem }
                                      );
                                    } else {
                                      handleChangeOption(idx);
                                    }
                                  }}
                                >
                                  {listItem.name}
                                </Link>

                                {listItem?.child_category?.length > 0 && (
                                  <div className="d-flex flex-wrap subList justify-content-center">
                                    {listItem?.child_category?.map(
                                      (childItem, childItemIdx) => (
                                        <Link
                                          to=""
                                          key={childItemIdx}
                                          className={`subList_tab ${state.activeChild?.parentIndex ===
                                              idx &&
                                              state.activeChild?.childIndex ===
                                              childItemIdx
                                              ? "active"
                                              : ""
                                            }`}
                                          onClick={(e) => {
                                            e.preventDefault();
                                            handleChangeOption(
                                              idx,
                                              childItemIdx
                                            );
                                          }}
                                        >
                                          {childItem.name}
                                        </Link>
                                      )
                                    )}
                                  </div>
                                )}
                              </ListGroup.Item>
                            ))}
                          </ListGroup>
                        </>
                      </div>
                    </>
                  ) : (
                    <div className="d-flex justify-content-center align-items-center vh-100">
                      No data found
                    </div>
                  )}
                </div>
              </div>
              <Link
                className="commonBack text-uppercase d-block h-auto"
                to={userRouteMap.LANDING.path}
              >
                <em className="icon-back" />
                <span className="d-block">Back</span>
              </Link>
            </Col>
          </div>
        </Container>
      </div>
    </>
  );
}

export default MeetingRoom;
